import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#e65100', light: '#ff833a', dark: '#ac1900' },
    secondary: { main: '#1565c0', light: '#5e92f3', dark: '#003c8f' },
    background: { default: '#fff3e0', paper: '#ffffff' },
    success: { main: '#2e7d32' },
    error: { main: '#c62828' },
    warning: { main: '#e65100' },
  },
  typography: {
    fontFamily: '"Inter", "Noto Sans TC", "Roboto", sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, borderRadius: 8 },
        containedPrimary: {
          background: 'linear-gradient(135deg, #e65100 0%, #ff6d00 100%)',
          '&:hover': { background: 'linear-gradient(135deg, #bf360c 0%, #e65100 100%)' },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 12, boxShadow: '0 2px 16px rgba(230,81,0,0.07)' },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(135deg, #bf360c 0%, #e65100 50%, #ff6d00 100%)',
          boxShadow: '0 2px 20px rgba(191,54,12,0.35)',
        },
      },
    },
    MuiChip: { styleOverrides: { root: { fontWeight: 600 } } },
    MuiTextField: {
      styleOverrides: {
        root: { '& .MuiOutlinedInput-root': { borderRadius: 8 } },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        bar: { background: 'linear-gradient(90deg, #e65100, #ff6d00)' },
      },
    },
  },
});

export default theme;
